import React, { useState } from 'react';
import { DatePicker } from 'antd';
import { ShortCutItem, DatePickContainer } from './styled';
import moment from 'moment';

const { RangePicker } = DatePicker;

enum ShortCut {
  Hours24 = '24 hours',
  Day7 = '7 days',
  Day15 = '15 days',
  Day30 = '30 days',
}

const shortcutsList = [ShortCut.Hours24, ShortCut.Day7, ShortCut.Day15, ShortCut.Day30];

function getShortCutTime(shortCut: string) {
  const [value, unit] = shortCut.split(' ');
  return [moment().subtract(+value, unit as 'hours' | 'days'), moment()];
}

export default function DatePickerComp({ value, onTimeChange }) {
  const [currentShortCut, setShortCut] = useState('24 hours');

  return (
    <DatePickContainer>
      {shortcutsList.map((shortCutLabel) => {
        return (
          <ShortCutItem
            key={shortCutLabel}
            style={{
              background: shortCutLabel === currentShortCut ? '#fff' : '#f6f6f6',
              color: shortCutLabel === currentShortCut ? '#0046FF' : '#000',
              borderColor: shortCutLabel === currentShortCut ? '#0046FF' : '#d0d0d0',
            }}
            onClick={() => {
              setShortCut(shortCutLabel);
              onTimeChange(getShortCutTime(shortCutLabel));
            }}
          >
            {shortCutLabel}
          </ShortCutItem>
        );
      })}
      <RangePicker
        style={{
          borderTopLeftRadius: '0',
          borderBottomLeftRadius: '0',
        }}
        showTime={{ format: 'HH:mm' }}
        format="YYYY-MM-DD HH:mm"
        value={value}
        onChange={(value) => {
          onTimeChange(value);
          setShortCut('');
        }}
      />
    </DatePickContainer>
  );
}
